"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answersSchema = void 0;
const zod_1 = require("zod");
const answer_schema_1 = require("./answer.schema");
exports.answersSchema = zod_1.z.array(answer_schema_1.answerSchema).min(1).describe("List of one or more answers");
